/**
 * Starting point of app customization
 * @module App
 */

import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from "./globals/scroll-to-top";
import RootLayout from "./layouts/root-layout";
import CookieConsentBanner from "./app/components/CookieConsentBanner";
import { useEffect } from "react";
import { initializeAnalytics } from "./utils/simpleAnalytics";

/**
 * 
 * First Element inside {@link AppRoutes | app flow} contained inside {@link RootLayout | app layout}
 * @returns - Outer most markup for the template.
 */
const App = () => {
  // Initialize analytics on app start
  useEffect(() => {
    initializeAnalytics();
  }, []);

  return (
    <HelmetProvider>
      <ScrollToTop />
      <RootLayout />
      <CookieConsentBanner />
    </HelmetProvider>
  );
}

export default App;
